import firebase from 'firebase'
import functions from 'firebase/functions'
import db from '@/firebase/init'
import { data } from 'autoprefixer';
import moment from "moment";

const state = {
    bookings: [

    ],
    office_bookings: [

    ],
    office_timestamp_bookings: [

    ],
    my_bookings: [

    ],
    my_timestamp_bookings: [

    ],
    all_bookings: [

    ],
    all_unapproved_bookings: [

    ],
    booking: null
};

const getters = {
    allBookings: (state) => state.bookings, 
    officeBookings: (state) => state.office_bookings,
    officeTimestampBookings: (state) => state.office_timestamp_bookings,
    selectedBooking: (state) => state.booking,
    myBookings: (state) => state.my_bookings,
    myTimestampBookings: (state) => state.my_timestamp_bookings,
    allBookings: (state) => state.all_bookings,
    allUnapprovedBookings: (state) => state.all_unapproved_bookings,
}
 
const actions = {
    async getAllBookings({ commit }) {
        var bookings = [];

        var d = new Date();
        d.setHours(0, 0, 0, 0);
        var lastMidnight = d.getTime() - (86400000 * 5);

        //Get data from the firestore
        var collection = db.collection('bookings')
        const response = await collection.where('timestamp', '>', lastMidnight).get();
        response.forEach(doc => {
            let booking = doc.data()
            booking.id = doc.id
            bookings.push(booking);
        });
        console.log("1 is: " + bookings.length)
        commit('setBookings', bookings)
    },
    async setOfficeBookings({ commit }, officeid) {

        var d = new Date();
        d.setHours(0, 0, 0, 0);
        var lastMidnight = d.getTime() - (86400000);

        console.log("Set Bookings")
        var bookings = [];
        //Get data from the firestore
        var response = await db.collection('bookings').where('officeid', '==', officeid).where('timestamp', '>', lastMidnight).get()
        response.forEach(doc => {
            let booking = doc.data()
            booking.id = doc.id
            bookings.push(booking);
        });
        console.log("2 is: " + bookings.length)
        commit('setStateOfficeBookings', bookings)
    },
    async setOfficeTimestampBookings({ commit }, info) {
        console.log(info.timestamp)
        //info.timestamp to readable date (dd-mm-yyyy)
        console.log(moment(info.timestamp).format("DD-MM-YYYY"))
        // console.log(moment.unix(info.timestamp/1000).format("MM/DD/YYYY h:mm:ss a"))
        console.log("Set Bookings")
        var bookings = [];
        //Get data from the firestore
        // var response = await db.collection('bookings').where('officeid', '==', info.officeid).where("timestamp", ">=", (info.timestamp - 73000000)).where("timestamp", "<=", (info.timestamp + 73000000)).get()
        var response = await db.collection('bookings').where('officeid', '==', info.officeid).where("date_string", "==", moment(info.timestamp).format("DD-MM-YYYY")).get()
        response.forEach(doc => {
            let booking = doc.data()
            booking.id = doc.id
            bookings.push(booking);
        });
        console.log("3 is: " + bookings.length)
        commit('setOfficeTiemstampBookings', bookings)
    },
    async setAllUnapprovedBookings({ commit }){
        console.log("Set Unapproved Bookings")
        var bookings = [];
        //Get data from the firestore
        var response = await db.collection('bookings').where('approved', '==', false).get()
        response.forEach(doc => {
            let booking = doc.data()
            booking.id = doc.id
            bookings.push(booking);
        });
        console.log("4 is: " + bookings.length)
        commit('setUnapprovedBookings', bookings)
    },
    async setBooking({ commit }, bookingid) { 
        console.log("Set Booking")
        var booking = null;
        //Get data from the firestore
        var doc = await db.collection('bookings').doc(bookingid).get()
        booking = doc.data();
        booking.id = bookingid
        commit('setBooking', booking)
    },
    async createBooking({ commit }, info) {
        var user = firebase.auth().currentUser
        var ref = db.collection('bookings')
        var doc = await ref.add({
            employee: info.employee,
            timestamp: info.timestamp,
            officeid: info.officeid,
            user_id: user.uid,
            location: info.location,
            approved: true,
            email: user.email,
            why: info.why || null,
            created: moment().format('MMMM Do YYYY, h:mm:ss a')
        })
        var booking = info;
        booking.id = doc.id
        commit('addBooking', booking)
    },
    async createTimeSlotBooking({ commit }, info) {

        switch(info.shift) {
        case 1:
            var timeslot = '07:00 - 08:00'
            break;
        case 2:
            var timeslot = '08:00 - 09:00'
            break;
        case 3:
            var timeslot = '09:00 - 10:00'
            break;
        case 4:
            var timeslot = '10:00 - 11:00'
            break;
        case 5:
            var timeslot = '11:00 - 12:00'
            break;
        case 6:
            var timeslot = '12:00 - 13:00'
            break;
        case 7:
            var timeslot = '13:00 - 14:00'
            break;
        case 8:
            var timeslot = '14:00 - 15:00'
            break;
        case 9:
            var timeslot = '15:00 - 16:00'
            break;
        case 10:
            var timeslot = '16:00 - 17:00'
            break;
        case 11:
            var timeslot = '17:00 - 18:00'
            break;
        case 12:
            var timeslot = '18:00 - 19:00'
            break;
        case 13:
            var timeslot = '19:00 - 20:00'
            break;
          default:
            var timeslot = '07:00 - 08:00'
            break;
        }

        var user = firebase.auth().currentUser
        var ref = db.collection('bookings')
        var doc = await ref.add({
            employee: info.employee,
            timestamp: info.timestamp,
            officeid: info.officeid,
            user_id: user.uid,
            location: info.location,
            shift: info.shift,
            timeslot: timeslot,
            approved: true,
            email: user.email,
            why: info.why || null,
            date_string: info.date_string,
            groupID: info.groupID,
            all_day: info.all_day,
            created: moment().format('MMMM Do YYYY, h:mm:ss a'),
            createdDate: new Date(),
        })
        var booking = info;
        booking.id = doc.id
        commit('addBooking', booking)
    },
    async requestBooking({ commit }, info) {
        var user = firebase.auth().currentUser
        var target = {};
        target.user_id = null;

        //GET OFFICE BOOKINGS THAT DAY
        info.officebookings     = [];
        info.morningBookings    = [];
        info.afternoonBookings  = [];

        var collection = db.collection('bookings').where("timestamp", "==", info.timestamp).where("officeid", "==", info.officeid)
        const resp = await collection.get();
        resp.forEach(doc => {
            let office_booking = doc.data()
            office_booking.id = doc.id
            info.officebookings.push(office_booking);
        });
        //GET OFFICE BOOKINGS THAT DAY

        //SORT OFFICE BOOKINGS
        for(var i = 0; i < info.officebookings.length; i++){
            if(info.officebookings[i].shift == 1){
              info.morningBookings.push(info.officebookings[i])
              info.afternoonBookings.push(info.officebookings[i])
            } else if (info.officebookings[i].shift == 2){
              info.morningBookings.push(info.officebookings[i])
            } else if (info.officebookings[i].shift == 3) {
              info.afternoonBookings.push(info.officebookings[i])
            }
          }
          info.morningBookings.sort((a,b) => (a.employee > b.employee) ? 1 : ((b.employee > a.employee) ? -1 : 0)); 
          info.afternoonBookings.sort((a,b) => (a.employee > b.employee) ? 1 : ((b.employee > a.employee) ? -1 : 0));
          //SORT OFFICE BOOKINGS 

        if(user.email){
            var consultant = db.collection('users').where("email", "==", user.email);
            var response = await consultant.get();
            response.forEach(doc => {
                target = doc.data();
            });
            var d = new Date(info.timestamp);
            info.fullDate = d.toDateString();
            info.consultant_email = user.email;
            var ref = db.collection('bookings')
            var doc = await ref.add({
                employee: info.employee,
                timestamp: info.timestamp,
                officeid: info.officeid,
                user_id: user.uid,
                location: info.location,
                approved: true,
                shift: info.shift,
                license_plate: info.license_plate,
                // reason: info.reason,
                email: user.email,
                created: moment().format('MMMM Do YYYY, h:mm:ss a'),
                date_string: info.date_string,
                groupID: info.groupID,
                createdDate: new Date(),
            })
            var booking = info;
            booking.id = doc.id;
            info.bookingid = booking.id;

            // console.log(info);

            // var sendEmail = firebase.functions().httpsCallable('sendApprovalEmail');
            // sendEmail({ data: info }).then((result)=>{
            //     console.log(result);
            // })
            commit('addBooking', booking);
        }
    },
    async approveBooking({commit}, info) {
        const approvedBookingId = info.bookingid;
        if(info.status == 1){
            await db.collection('bookings').doc(info.bookingid).update({ approved: true }).then(async ()=>{
                console.log("Booking approved")
                var doc = await db.collection('bookings').doc(approvedBookingId).get()
                var booking_info = doc.data();
                console.log(booking_info)
                if(booking_info.email){
                    var consultant = db.collection('users').where("email", "==", booking_info.email);
                    var response = await consultant.get();
                    var target = {};
                    target.user_id = null;
                    response.forEach(doc => {
                        target = doc.data();
                    });
                    var d = new Date(booking_info.timestamp);
                    booking_info.fullDate = d.toDateString();
                    var sendEmail = firebase.functions().httpsCallable('sendConfirmationApprovalEmail');
                    sendEmail({ data: booking_info }).then((result)=>{
                        console.log(result);
                    })
                }
            }).catch((err) => {
                console.log(err)
            })
        } else {
           await db.collection('bookings').doc(info.bookingid).update({ approved: false }).then(async ()=>{
                console.log(approvedBookingId)
                console.log("Booking denied")
                var doc = await db.collection('bookings').doc(approvedBookingId).get()
                var booking_info = doc.data();
                if(booking_info.email){
                    var consultant = db.collection('users').where("email", "==", booking_info.email);
                    var response = await consultant.get();
                    var target = {};
                    target.user_id = null;
                    response.forEach(doc => {
                        target = doc.data();
                    });
                    var d = new Date(booking_info.timestamp);
                    booking_info.fullDate = d.toDateString();
                    var sendEmail = firebase.functions().httpsCallable('sendConfirmationDenialEmail');
                    sendEmail({ data: booking_info }).then((result)=>{
                        console.log(result);
                    })
                }
            }).catch((err) => {
                console.log(err)
            })
        }
    },
    async denyBooking({commit}, info) {

        console.log(info)

        const approvedBookingId = info.bookingid;
        
        var doc = await db.collection('bookings').doc(approvedBookingId).get()
        const booking = doc.data()

        db.collection('bookings').doc(approvedBookingId).delete()
        .then(()=>{
            commit('removeBooking', bookingid)
        })

        var d = new Date(booking.timestamp);
        booking.fullDate = d.toDateString();
        booking.reason = info.reason;
        var sendEmail = firebase.functions().httpsCallable('sendConfirmationDenialEmail');
        sendEmail({ data: booking }).then((result)=>{
            console.log(result);
        })
    },
    async createSecretaryBooking({ commit }, info) {
        var user = firebase.auth().currentUser
        var ref = db.collection('bookings')
        var target = {};
        target.user_id = null;
        if(info.email){
            var consultant = db.collection('users').where("email", "==", info.email);
            var response = await consultant.get();
            response.forEach(doc => {
                target = doc.data();
            });
            var d = new Date(info.timestamp);
            info.fullDate = d.toDateString();
            var sendEmail = firebase.functions().httpsCallable('sendConfirmationEmail');
            sendEmail({ data: info }).then((result)=>{
                console.log(result);
            })
        }
        console.log("The id of the target is: " + target.user_id);
        var doc = await ref.add({
            email: info.email,
            employee: info.employee,
            timestamp: info.timestamp,
            officeid: info.officeid,
            shift: info.shift,
            creator_id: user.uid,
            user_id: target.user_id,
            location: info.location,
            email: info.email,
            why: info.why || null,
            created: moment().format('MMMM Do YYYY, h:mm:ss a'),
            date_string: info.date_string,
            groupID: info.groupID,
            createdDate: new Date(),
        })
        var booking = info;
        booking.id = doc.id
        commit('addBooking', booking)
    },
    async createSecretaryRequest({ commit }, info) {
        var user = firebase.auth().currentUser
        var ref = db.collection('bookings')
        var target = {};
        target.user_id = null;

         //GET OFFICE BOOKINGS THAT DAY
         info.officebookings     = [];
         info.morningBookings    = [];
         info.afternoonBookings  = [];
 
         var collection = db.collection('bookings').where("timestamp", "==", info.timestamp).where("officeid", "==", info.officeid)
         const resp = await collection.get();
         resp.forEach(doc => {
             let office_booking = doc.data()
             office_booking.id = doc.id
             info.officebookings.push(office_booking);
         });
         //GET OFFICE BOOKINGS THAT DAY
 
         //SORT OFFICE BOOKINGS
         for(var i = 0; i < info.officebookings.length; i++){
             if(info.officebookings[i].shift == 1){
               info.morningBookings.push(info.officebookings[i])
               info.afternoonBookings.push(info.officebookings[i])
             } else if (info.officebookings[i].shift == 2){
               info.morningBookings.push(info.officebookings[i])
             } else if (info.officebookings[i].shift == 3) {
               info.afternoonBookings.push(info.officebookings[i])
             }
           }
           info.morningBookings.sort((a,b) => (a.employee > b.employee) ? 1 : ((b.employee > a.employee) ? -1 : 0)); 
           info.afternoonBookings.sort((a,b) => (a.employee > b.employee) ? 1 : ((b.employee > a.employee) ? -1 : 0));
           //SORT OFFICE BOOKINGS 

        if(info.email){
            var consultant = db.collection('users').where("email", "==", info.email);
            var response = await consultant.get();
            response.forEach(doc => {
                target = doc.data();
            });
            var d = new Date(info.timestamp);
            info.fullDate = d.toDateString();
            info.consultant_email = info.email;
            var ref = db.collection('bookings')
            var doc = await ref.add({
                employee: info.employee,
                timestamp: info.timestamp,
                officeid: info.officeid,
                user_id: user.uid,
                creator_id: user.uid,
                location: info.location,
                approved: true,
                shift: info.shift,
                license_plate: info.license_plate,
                // reason: info.reason,
                why: info.why || null,
                email: info.email,
                external: info.external,
                created: moment().format('MMMM Do YYYY, h:mm:ss a'),
                date_string: info.date_string,
                groupID: info.groupID,
                createdDate: new Date(),
            })
            var booking = info;
            booking.id = doc.id;
            info.bookingid = booking.id;

            // var sendEmail = firebase.functions().httpsCallable('sendApprovalEmail');
            // sendEmail({ data: info }).then((result)=>{
            //     console.log(result);
            // })
        }

        var booking = info;
        booking.id = doc.id
        commit('addBooking', booking)
    },
    async setMyBookings({ commit }) {

        var start = new Date().getTime();
        var user = firebase.auth().currentUser
        var bookings = [];

        console.log(user)

        var collection = db.collection('users').where("email", "==", user.email);
        const answer = await collection.get();

        // console.log(answer)
        answer.forEach(doc => {
            if(doc.data().oldEmail){
                user.old_email = doc.data().oldEmail;
            } else {
                user.old_email = null;
            }
        });

        // Query by user_id
        let bookingsByUid = [];
        var bookingsById = await db.collection('bookings')
        .where("timestamp", ">=", start - 86400000)
        .where('user_id', '==', user.uid)
        .get();

        if(bookingsById){
            bookingsByUid = bookingsById.docs;
        }

        // Query by old_email (if it exists)
        let bookingsByOldEmail = [];
        if (user.old_email) {
            var resp = await db.collection('bookings')
            .where("timestamp", ">=", start - 86400000)
            .where('email', '==', user.old_email)
            .get();
            if(resp){
                bookingsByOldEmail = resp.docs;
            }
        }

        // Combine results
        var bookings = [];

        if(bookingsByUid) {
            bookingsByUid.forEach(doc => {
                let booking = doc.data();
                booking.id = doc.id;
                bookings.push(booking);
            });
        }

        if(bookingsByOldEmail) {
            bookingsByOldEmail.forEach(doc => {
                let booking = doc.data();
                booking.id = doc.id;
                bookings.push(booking);
            });
        }

        commit('setMyBookings', bookings)

    },
    async setMyTimestampBookings({ commit }, info) {

        var timestamp = info.timestamp
        var user = firebase.auth().currentUser

        var collection = db.collection('users').where("email", "==", user.email);
        const answer = await collection.get();

        answer.forEach(doc => {
            console.log(doc.data())
            if(doc.data().oldEmail){
                user.old_email = doc.data().oldEmail;
            } else {
                user.old_email = null;
            }
        });

        //Get data from the firestore
        var bookingsByUid = [];
        var bookingsByID = await db.collection('bookings').where("timestamp", "==", info.timestamp).where('user_id', '==', user.uid).get();

        if (bookingsByID) {
            bookingsByUid = bookingsByID.docs;
        }

        let bookingsByOldEmail = [];
        if (user.old_email) {
            var resp = await db.collection('bookings')
            .where("timestamp", "==", info.timestamp)
            .where('email', '==', user.old_email)
            .get();

            if(resp){
                bookingsByOldEmail = resp.docs;
            }
        }

        // Combine results
        var bookings = [];
        if (bookingsByUid) {
            bookingsByUid.forEach(doc => {
                let booking = doc.data();
                    booking.id = doc.id;
                    bookings.push(booking);
                });
        }

        if (bookingsByOldEmail) {
            bookingsByOldEmail.forEach(doc => {
                let booking = doc.data();
                    booking.id = doc.id;
                    bookings.push(booking);
                });
        }

        commit('setMyTimestampBookings', bookings)

    },
    async setAllBookings({ commit }) {
        var bookings = [];
        //Get data from the firestore
        var collection = db.collection('bookings')
        const response = await collection.get();
        response.forEach(doc => {
            let booking = doc.data()
            booking.id = doc.id
            bookings.push(booking);
        });
        console.log(bookings)
        commit('setAllBookings', bookings)
    },
    async setAllBookingsByDateRange({ commit }, dates) {
        var start = dates.start;
        var end = dates.end;
        var bookings = [];
        //Get data from the firestore
        var collection = db.collection('bookings').where("timestamp", ">=", start-86400000).where("timestamp", "<=", end)
        const response = await collection.get();
        response.forEach(doc => {
            let booking = doc.data()
            booking.id = doc.id
            bookings.push(booking);
        });
        console.log(bookings)
        commit('setAllBookings', bookings)
    },
    async deleteBooking({ commit }, bookingid){

        var doc = await db.collection('bookings').doc(bookingid).get()
        let booking = doc.data()
        console.log(booking);

        db.collection('bookings').doc(bookingid).delete()
        .then(()=>{
            commit('removeBooking', bookingid)
        })

        var d = new Date(booking.timestamp);
        booking.fullDate = d.toDateString();
        var sendEmail = firebase.functions().httpsCallable('sendCancellationEmail');
        sendEmail({ data: booking }).then((result)=>{
            console.log(result);
        })
    }
}

const mutations = {
    setBookings: (state, bookings) => (state.bookings = bookings),
    setUnapprovedBookings: (state, bookings) => (state.all_unapproved_bookings = bookings),
    setStateOfficeBookings: (state, bookings) => (state.office_bookings = bookings),
    setOfficeTiemstampBookings: (state, bookings) => (state.office_timestamp_bookings = bookings),
    setBooking: (state, booking) => (state.booking = booking),
    addBooking: (state, booking) => (state.office_bookings.push(booking)),
    setAllBookings: (state, bookings) => (state.all_bookings = bookings),
    setMyBookings: (state, bookings) => (state.my_bookings = bookings),
    setMyTimestampBookings: (state, bookings) => (state.my_timestamp_bookings = bookings),
    removeBooking: (state, bookingid) => (state.my_bookings = state.my_bookings.filter(x => x.id != bookingid)),
}

export default {
    state,
    getters,
    actions, 
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bookings.js